import newAdapter from "./newAdapter";
import imageCompression from "browser-image-compression"

const validateMicrosoftFile = (fileName: string): boolean => {
  const extension = fileName?.split(".").pop()
  const isMicrosoftFile =
    extension === "doc" ||
    extension === "docx" ||
    extension === "xls" ||
    extension === "xlsx"

  return isMicrosoftFile
}

const resizeImageTo60KB = async (file: any) => {
  const options = {
    maxSizeMB: 0.06, // 60 KB
    maxWidthOrHeight: 1024,
    useWebWorker: true,
  }
  try {
    const compressedFile = await imageCompression(file, options)
    return compressedFile
  } catch (error) {
    console.error(error)
  }
}

const buildMenuActiveMap = (allMenu: any): Record<string, boolean> => {
  
  const map: Record<string, boolean> = {}
  allMenu?.menus?.forEach((parent: any) => {
    map[parent.menu_id] = parent.is_active
    parent.children?.forEach((child: any) => {
      map[child.children_id] = child.is_active
    })
  })

  return map
}

export {
  newAdapter,
  validateMicrosoftFile,
  resizeImageTo60KB,
  buildMenuActiveMap,
}